import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-099518f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM, SUFFIX, PRODUCT_TYPE } from '@/common'
import { useProductStore } from '@/stores/product'
import {
  productInfoAdd,
  productInfoUpdate,
  queryProductInfo,
  queryProductThingModelList,
} from '@/api'
import CommonUpload from '@/components/common-upload'


export default /*#__PURE__*/_defineComponent({
  __name: 'product-form-drawer',
  props: ['visible', 'data', 'productTypeOps'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

const singleGatewayOps = [
  {
    value: 'WS-A101',
  },
  {
    value: 'WS-A102',
  },
  {
    value: 'WS-A103',
  },
  {
    value: 'WS-A401',
  },
  {
    value: 'WS-A402',
  },
]

const formData = ref({
  productImage: '',
  productName: '',
  productType: '',
  brand: '',
  producer: '',
  productModel: '',
  remarks: '',
  thingModelId: '',
  producerCode: '',
})
const rules: any = {
  productName: [{ required: true, message: '请输入' }],
  productType: [{ required: true, message: '请选择' }],
  producer: [{ required: true, message: '请输入' }],
  productModel: [{ required: true, message: '请输入' }],
  producerCode: [{ required: true, message: '请输入' }],
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetail()
      queryModalList()
    }
  }
)

const modalList: any = ref([])
const queryModalList = async () => {
  const res: any = await queryProductThingModelList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    modalList.value = res.data || []
  }
}

const defaultImg = ref('')
const detailLoading = ref(false)
const queryDetail = async () => {
  if (!props.data.productKey) {
    return
  }
  detailLoading.value = true
  const res: any = await queryProductInfo({
    productKey: props.data.productKey,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    detailLoading.value = false
    const {
      productImageBaseUrl,
      productImage,
      productName,
      productType,
      brand,
      producer,
      productModel,
      remarks,
      thingModelId,
      producerCode,
    }: any = res.data

    formData.value = {
      productImage,
      productName,
      productType,
      brand,
      producer,
      productModel,
      remarks,
      thingModelId,
      producerCode,
    }
    if (productImageBaseUrl && productImage) {
      defaultImg.value = productImageBaseUrl + productImage
    }
  }
}

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
  defaultImg.value = ''
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleAddDevice = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const fn = props.data.productKey ? productInfoUpdate : productInfoAdd
      const res: any = await fn({
        ...formData.value,
        productKey: props.data.productKey,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: props.data.productKey ? '修改产品成功' : '新建产品成功',
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

const onProductTypeChange = () => {
  formData.value.productModel = ''
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: props.data.productKey ? '编辑产品' : '添加产品',
    size: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleAddDevice
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "productImage",
              label: "产品图"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CommonUpload), {
                  modelValue: formData.value.productImage,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.productImage) = $event)),
                  defaultImg: defaultImg.value
                }, null, 8, ["modelValue", "defaultImg"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "productName",
              label: "产品名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.productName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.productName) = $event)),
                  maxlength: "20",
                  placeholder: "请输入产品名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "productType",
              label: "类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.productType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.productType) = $event)),
                  placeholder: "请选择产品类型",
                  class: "ws_select",
                  filterable: "",
                  onChange: onProductTypeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productTypeOps, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "thingModelId",
              label: "模板名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.thingModelId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.thingModelId) = $event)),
                  placeholder: "请选择模板",
                  class: "ws_select",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.modelName,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "producer",
              label: "厂商"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.producer,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.producer) = $event)),
                  maxlength: "50",
                  placeholder: "请输入厂商"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "producerCode",
              label: "英文名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.producerCode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.producerCode) = $event)),
                  maxlength: "50",
                  placeholder: "请输入英文名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "brand",
              label: "品牌"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.brand,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.brand) = $event)),
                  maxlength: "50",
                  placeholder: "请输入品牌名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (formData.value.productType === _unref(PRODUCT_TYPE).SINGLE_GATEWAY)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "productModel",
                  label: "硬件代码"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.productModel,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.productModel) = $event)),
                      placeholder: "请选择硬件代码",
                      class: "ws_select",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(singleGatewayOps, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.value,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: "productModel",
                  label: "硬件代码"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.productModel,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.productModel) = $event)),
                      maxlength: "50",
                      placeholder: "请输入产品硬件代码"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })),
            _createVNode(_component_el_form_item, {
              prop: "remarks",
              label: "备注"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.remarks,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.remarks) = $event)),
                  maxlength: "500",
                  placeholder: "请输入你的备注",
                  rows: 4,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})